import React, { useEffect, useState } from 'react'
import './Remote.scss'
import Select from 'react-select';
import Form from 'react-bootstrap/Form';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { AiFillCaretDown } from "react-icons/ai";
import Accordion from 'react-bootstrap/Accordion';
import happimobileslogo from '../../assets/happimobileslogo.png'

import { FaArrowAltCircleUp,FaArrowAltCircleDown,FaArrowAltCircleLeft, FaArrowAltCircleRight} from "react-icons/fa";

import { io } from "socket.io-client";
import { toast } from 'react-toastify';
import { DateTime } from 'luxon';


const socket = io("https://mis-api.happimobiles.com", {
  withCredentials: true,
});




const Remote = () => {
  const [filter, setShowFilter] = useState({ showSalesDRFilter: false, showMisFilter: false, filterName: "", showRight: false,showFilterRight:false,showFinacialFilter:false });
  const todayDate = new Date();
  todayDate.setDate(todayDate.getDate() - 1);
  const [storeOption, setStoreOption] = useState("Ameerpet");
  const [selectedAsms, setSelectedAsms] = useState("");
  const [state, setSelectedState] = useState("");
  const [customStartDate, setCustomStartDate] = useState(moment(new Date(todayDate)).format("YYYY/MM/DD"));
  const [customEndDate, setCustomEndDate] = useState(moment(new Date(todayDate)).format("YYYY/MM/DD"));
  const [radioValue, setRadioValue] = useState("FTD");
  const [stateHeads, setStateHeads] = useState([]);
  const [asmsList, setAsmsList] = useState([]);
  const [storeList, setStoreList] = useState([]);
  const [activeAccordian,setActiveAccordian]=useState('');
  const [socketStatus, setSocketStatus] = useState("");
  const [qrCode,setQRCode]=useState('');
  let date = new Date(),
    y = date.getFullYear(),
    m = date.getMonth();


  
  useEffect(() => {
    let url = new URL(window.location.href);
    let urlsp = url.searchParams;
    setQRCode(urlsp.get('qrcode'))
    getStateHeads()
    socket.on("connect", () => {
      setSocketStatus("Connected")
      console.log(socket.id, "connected")

    });
    socket.on('filter', (data) => {
      console.log(data)
    })
    socket.on("disconnect", () => {
      setSocketStatus("Disconnected")
      console.log(socket.id, "disconnecteed"); // undefined
    });
    document.title="Remote"


  }, [])

  const getStateHeads = async () => {
    try{
      let response = await fetch('https://mis-api.happimobiles.com/api/tvDashboard/getStateHeads');
      let result = await response.json()
      if (result.status) setStateHeads(result.rows)
    }
      catch(e){
        toast.error("Network error")
    }
  }

//functions to send data to Dropdowns 
  const getStateHeadOptions = () => stateHeads.length > 0 ? [...stateHeads.map(item => ({ value: item.id, label: item.region })),{value:"All",label:"All"}] : [];
  const getAsmOptionsList = () => asmsList.length > 0 ? asmsList.map(item => ({ value: item.id, label: item.asm_name })) : [];
  const getStoreOptionList = () => storeList.length > 0 ? storeList.map(item => ({ value: item.id, label: item.store_name })) : [];


//functions that will handle on dropdown value change or selection 
  const onStateValueChange = async (val) => {
    if(val?.value=="All"){
      setSelectedState(val);
      setSelectedAsms({label:"All",value:"All"});
      setStoreOption({label:"All",value:"All"});
      return
    }
    if (!val) return setSelectedState()
    setSelectedState(val);
    setSelectedAsms();
    setStoreOption();
    let response = await fetch(`https://mis-api.happimobiles.com/api/tvDashboard/getASM?state_head_id=${val?.value}`);
    let result = await response.json();
    if (result?.status) setAsmsList(result?.rows)
  }
  const onAsmValueChange = async (val) => {
    if (!val) return setSelectedAsms()
    setSelectedAsms(val);
    let response = await fetch(`https://mis-api.happimobiles.com/api/tvDashboard/getStores?asm_id=${val?.value}`);
    let result = await response.json();
    if (result?.status) setStoreList(result?.rows)
  }

//function that will handle payload data on submit and sends selected filter data to T.V. dashboard through socket
  const handleSubmit = () => {
    let payload = {
      filtername: filter.filterName,
      state: state,
      asm: selectedAsms,
      store: storeOption,
      type: radioValue,
      uuid:qrCode
    }
    console.log("payload",payload)

    if (radioValue == 'CUSTOM') {
      let startDate=new Date(customStartDate)
      let endDate=new Date(customEndDate)
      if(startDate.getMonth()!=endDate.getMonth()){
        toast.error("Please Select Dates on same Month")
        return
      }
      if((startDate.getMonth()==endDate.getMonth())&&(startDate.getFullYear()!=endDate.getFullYear())){
        toast.error("Please Select Same year")
        return
      }
      payload['customdates'] = {
        startdate:new Date(new Date(customStartDate).getTime()+86400000),
        endDate:new Date(new Date(customEndDate).getTime()+86400000)
      }
    }
    if (socketStatus == "Connected") socket.emit('filter', payload)
    else alert("socket status:" + socketStatus)
  }

  const scrollUp=()=>{
    socket.emit('scroll', {uuid:qrCode,type:"up"})
  }
  const scrollDown=()=>{
    socket.emit('scroll', {uuid:qrCode,type:"down"})
  }
  const scrollLeft=()=>{
    socket.emit('scroll', {uuid:qrCode,type:"left"})
  }
  const scrollRight=()=>{
    socket.emit('scroll',{uuid:qrCode,type:"right"})
  }

  //Range Date Picker To select multiple values
  const handleDateChange = ([newStartDate, newEndDate]) => {
    setCustomStartDate(newStartDate);
    setCustomEndDate(newEndDate);
  }

  //function to clear all selected filter data when click on clear all button
  const handleClearAll = () => {
    setCustomStartDate(moment(new Date(todayDate)).format("YYYY/MM/DD"));
    setCustomEndDate(moment(new Date(todayDate)).format("YYYY/MM/DD"));
    setSelectedState("")
    setStoreOption("");
    setSelectedAsms("")
    setRadioValue("FTD")
  }
  const FilterReport = () => {
    return (
      <div className='row'>
        <div className={`${filter.showFilterRight && `offset-6`} col-6 d-flex align-items-center justify-content-center`}>
          {/* <AiFillCaretDown size={25} /> */}
        </div>
        <div className='col-12'>
          <div className='filter-bg p-2'>
            <div className='d-flex gap-5'>
            <h1>Filter</h1>
            <FaArrowAltCircleUp size={25} onClick={scrollUp} />
            </div>
            <div className='d-flex align-items-center gap-1'>
              <span><FaArrowAltCircleLeft  size={25} onClick={scrollLeft} />
              </span>
            <div className='w-100'>
            <div className="d-flex align-items-center mt-2 mt-sm-2 mb-1 ">
              {/* <label className="state-head-label">States:</label> */}
              <Select
                placeholder={"State..."}
                isClearable={true}
                value={state}
                onChange={onStateValueChange}
                options={getStateHeadOptions()}
              
              />
            </div>

            <div className="d-flex align-items-center  mt-2 mt-sm-2 mb-1 w-100">
             
              <Select
                placeholder={"ASM.."}
                isClearable={true}
                value={selectedAsms}
                onChange={onAsmValueChange}
                options={getAsmOptionsList()}
                isDisabled={state?.value=='All'}
              />
            </div>
            </div>
            <span><FaArrowAltCircleRight  size={25} onClick={scrollRight} /></span>
            </div>
           
            {
            filter.filterName!="Reports"&&<>
              <div className="d-flex align-items-center justify-content-between mt-2 mt-sm-2 mb-1 w-100">
              <Select
                placeholder={"Store..."}
                isClearable={true}
                value={storeOption}
                onChange={setStoreOption}
                options={getStoreOptionList()}
                isDisabled={state?.value=='All'}
              />
            </div>
            <div>
              <Form.Check 
                type={"radio"}
                name="filter"
                id={`radio`}
                label={`FTD`}
                value="FTD"
                checked={radioValue == 'FTD'}
                onChange={(val) => setRadioValue(val.target.value)}
              />
              <Form.Check 
                type={"radio"}
                id={`radio`}
                name="filter"
                value="MTD"
                label={`MTD`}
                checked={radioValue == 'MTD'}
                onChange={(val) => setRadioValue(val.target.value)}
              />
              <Form.Check
                type={"radio"}
                id={`radio`}
                name="filter"
                label={`CUSTOM`}
                value="CUSTOM"
                checked={radioValue == 'CUSTOM'}
                onChange={(val) => setRadioValue(val.target.value)}
              />
              {
                radioValue == 'CUSTOM' &&

                <div className="d-flex align-items-center w-100 gap-2 selectdate mb-2">
                  <DatePicker
                    selected={customStartDate}
                    onChange={handleDateChange}
                    selectsRange
                    isClearable
                    startDate={customStartDate}
                    endDate={customEndDate}
                    maxDate={new Date()}
                    dateFormat="dd/MM/yyyy"
                    minDate={new Date(y, 5)}
                  />
                </div>}
            </div>
            </>
            }
          
            <div className='d-flex gap-2 justify-content-between p-2 footer-btns'>
              <div className='d-flex gap-3'>
            </div>

              <div className='d-flex gap-2'>
              <FaArrowAltCircleDown size={25} onClick={scrollDown}/>

              <button className='btn btn-danger' onClick={handleClearAll}>Clear All</button>
              <button className='btn btn-danger' onClick={handleSubmit}>Submit</button>
              </div>
            </div>
          </div>
        </div>

      </div>

    )

  }

  return (
    <>
    {/* <div className='title-logo'>
      <img src={happimobileslogo} height={"50px"}  width={"70px"}/>
    </div> */}
      <div className='row mt-2 accordian-header'>
      <Accordion onSelect={(e)=>setActiveAccordian(e)} >
      <Accordion.Item eventKey="Sales">
        <Accordion.Header className={`${activeAccordian=="Sales"?"active-acc":"inactive-acc"}`}>Sales</Accordion.Header>
        <Accordion.Body>
        <div >
   <div className={`${filter.showRight && `offset-6`} col-6 d-flex align-items-center justify-content-center`}>
      {/* <AiFillCaretDown size={25} /> */}
    </div>
    <div className='d-flex mt-2 gap-2'>
    <div className={`col-6 d-flex align-items-center justify-content-center ${filter.filterName=="Dashboard"?"bxs":"bxs-inactive"}`} onClick={() => setShowFilter(prev => ({ ...prev,showSalesFilterDashboardReports:true, showMisFilter: false, filterName: "Dashboard",showFilterRight: false }))}>
      <p>Dashboard</p>
    </div>

    <div className={`col-6 d-flex align-items-center justify-content-center ${filter.filterName=="Reports"?"bxs":"bxs-inactive"}`} onClick={() => setShowFilter(prev => ({...prev, showMisFilter: false, filterName: "Reports", showFilterRight: true,showSalesFilterDashboardReports:true }))}>
      <p>Reports</p>
    </div>
    </div>
   </div>
   <div className='col-12'>
          {
           filter?.showSalesFilterDashboardReports && <div className='animi mt-2'>
              <FilterReport />
            </div>
          }

        </div>
       
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="Financial">
        <Accordion.Header className={`${activeAccordian=="Financial"?"active-acc":"inactive-acc"}`}>Financial</Accordion.Header>
        <Accordion.Body>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="MIS">
        <Accordion.Header  className={`${activeAccordian=="MIS"?"active-acc":"inactive-acc"}`}>MIS</Accordion.Header>
        <Accordion.Body>
        <FilterReport />

        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="Reports">
        <Accordion.Header className={`${activeAccordian=="Reports"?"active-acc":"inactive-acc"}`}>Reports</Accordion.Header>
        <Accordion.Body>
        <FilterReport />
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
        {/* <div className='col-6 d-flex align-items-center justify-content-center bxs' onClick={() => setShowFilter(prev => ({ showSalesDRFilter: prev.showSalesDRFilter == true || (prev.filterName == "Dashboard"||prev.filterName == "Reports")? !prev.showSalesDRFilter : true, showMisFilter: false, filterName: "Sales" }))}>
          <p>Sales</p>
        </div>

        <div className='col-6 d-flex align-items-center justify-content-center bxs ms-0' onClick={() => setShowFilter(prev => ({ showFinacialFilter: prev.showFinacialFilter == true && prev.filterName == "Financial" ? !prev.showFinacialFilter : true, showMisFilter: false, filterName: "Financial", showRight: prev.showFinacialFilter == true && prev.filterName == "Financial" ? !prev.showRight : true }))}>
          <p>Financial</p>
        </div> */}

{
   filter?.showSalesDRFilter&&<div className=''><div >
   <div className={`${filter.showRight && `offset-6`} col-6 d-flex align-items-center justify-content-center`}>
      <AiFillCaretDown size={25} />
    </div>
    <div className='d-flex mt-2'>
    <div className='col-6 d-flex align-items-center justify-content-center bxs' onClick={() => setShowFilter(prev => ({ ...prev,showSalesFilterDashboardReports:true, showMisFilter: false, filterName: "Dashboard",showFilterRight: false }))}>
      <p>Dashboard</p>
    </div>

    <div className='col-6 d-flex align-items-center justify-content-center bxs ms-0' onClick={() => setShowFilter(prev => ({...prev, showMisFilter: false, filterName: "Reports", showFilterRight: true,showSalesFilterDashboardReports:true }))}>
      <p>Reports</p>
    </div>
    </div>
   </div>

        <div className='col-10 m-auto'>
          {
           filter?.showSalesFilterDashboardReports && <div className='animi mt-2'>
              <FilterReport />
            </div>
          }

        </div>
        </div> }

        {/* <div className='col-6 d-flex align-items-center justify-content-center bxs mt-2' onClick={() => setShowFilter(prev => ({ showFinacialFilter: false, showSalesFilterDashboardReports:false,showMisFilter: (prev.showMisFilter == true && prev.filterName == 'MIS') ? !prev.showMisFilter : true, filterName: "MIS" }))}>
          <p>MIS</p>
        </div>
        <div className='col-6 d-flex align-items-center justify-content-center bxs ms-0 mt-2' onClick={() => setShowFilter(prev => ({ showFinacialFilter: false,showSalesFilterDashboardReports:false, showMisFilter: (prev.showMisFilter == true && prev.filterName == 'Reports') ? !prev.showMisFilter : true, filterName: "Reports", showRight: (prev.showMisFilter == true && prev.filterName == 'Reports') ? !prev.showRight : true, }))}>
          <p>Reports</p>
        </div> */}
        <div className='col-10 m-auto'>
          {
            filter.showMisFilter && <div className='animi mt-2'>
              <FilterReport />
            </div>
          }
        </div>
        <div>



        </div>

      </div>
    </>)
}

export default Remote